<template>
<div class="companyAuth">
    <div class="companyTitleAuthBox">
        <span>|</span>企业认证
    </div>
    <div class="form page-form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" label-position="left" size="mini">
            <el-form-item label="企业/组织全称" prop="unitname">
                <el-input v-model="ruleForm.unitname" placeholder="请输入企业/组织全称"></el-input>
            </el-form-item>
            <el-form-item label="企业/组织注册编号" prop="unitcode">
                <el-input v-model="ruleForm.unitcode" placeholder="请输入企业/组织注册编号"></el-input>
            </el-form-item>
            <el-form-item label="证件照片" prop="checkUnitImg">
                <upload class="idcardImage" :imgRule="imgRule" @setImage="getCompanyImg" :uploadType="uploadType"></upload>
                <div class="success title">照片样式</div>
                <div class="business-license-cls">
                    <img :src="businessLicenseUrl" alt="">
                </div>
                <div class="el-upload__tip">支持JPG／JPEG／PNG格式，大小不超过2M。</div>
            </el-form-item>
            <el-form-item label="法人姓名" prop="unitpersonname">
                <el-input v-model="ruleForm.unitpersonname" placeholder="请输入法人姓名"></el-input>
            </el-form-item>
            <el-form-item label="法人身份证号码" prop="unitpersonidno">
                <el-input v-model="ruleForm.unitpersonidno" placeholder="请输入法人身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="法人身份证照片" prop="checkCompanyImg">
                <upload class="idcardImage" :imgRule="imgRule" @setImage="getPersonImg" :uploadType="uploadType"></upload>
                <div class="success title">照片样式</div>
                <div class="handheld-idcard-cls">
                    <img :src="handheldIdcardUrl" alt="">
                </div>
                <div class="el-upload__tip">支持JPG／JPEG／PNG格式，大小不超过2M。</div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <el-button @click="cancel">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import {companyAuthMsg} from '@/api/accountApi'
import {formatFileInfo} from '@/common/js/tools'
export default {
    name: 'companyAuth',
    data() {
        // 验证姓名
        let checkName = (rule, value, callback) => {
            let nameRegular = /[a-zA-Z\u4E00-\u9FA5]+$/
            if (!nameRegular.test(value)) {
                callback(new Error('请输入正确的名字'))
            } else {
                callback()
            }
        }
        // 验证身份证号码
        let checkIdCard = (rule, value, callback) => {
            let idCardRegular = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if (!idCardRegular.test(value)) {
                callback(new Error('请输入正确的身份证号码'))
            } else {
                callback()
            }
        }
        // 验证企业组织注册编号
        let checkUnitCode = (rule, value, callback) => {
            let unitCodeRegular = /\d{15}/
            if (!unitCodeRegular.test(value)) {
                callback('请输入正确的工商注册号')
            } else {
                callback()
            }
        }
        // 验证企业图片
        let checkUnitImg = (rule, value, callback) => {
            if (!this.ruleForm.unitimageinfo.furl) {
                callback('请选择企业证件图片')
            } else {
                callback()
            }
        }
        // 验证法人身份证图片
        let checkCompanyImg = (rule, value, callback) => {
            if (!this.ruleForm.unitpersonimageinfo.furl) {
                callback('请选择法人身份证图片')
            } else {
                callback()
            }
        }
        return {
            businessLicenseUrl: require('@/common/images/other/business_license.png'),
            handheldIdcardUrl: require('@/common/images/other/handheld_idcard.png'),
            realName: false,
            ruleForm: {
                unitname: '', // 企业名称
                unitcode: '', // 企业注册编号
                unitpersonname: '', // 法人姓名
                unitpersonidno: '', // 法人身份证号码
                unitimageinfo: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }, // 企业证件信息
                unitpersonimageinfo: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                } // 法人证件信息
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg,image/gif',
                size: 2,
                width: 0,
                height: 0
            },
            rules: {
                unitname: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                    {min: 3, max: 15, message: '长度在 3 到1 5 个字符', trigger: 'blur'}
                ],
                unitcode: [
                    {required: true, message: '请输入企业/组织注册编号', trigger: 'blur'},
                    {validator: checkUnitCode, trigger: 'blur'}
                ],
                unitpersonname: [
                    {required: true, message: '请输入法人姓名', trigger: 'blur'},
                    {validator: checkName, trigger: 'blur'}
                ],
                unitpersonidno: [
                    {required: true, message: '请输入身份证号码', trigger: 'blur'},
                    {validator: checkIdCard, trigger: 'blur'}
                ],
                checkUnitImg: [
                    {validator: checkUnitImg, trigger: 'blur'}
                ],
                checkCompanyImg: [
                    {validator: checkCompanyImg, trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$confirm('确定要提交账户资料吗？提交后我们需要1～3个工作日进行审核！亲耐心等待。', '提交资料', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.ruleForm.unitimageinfo = formatFileInfo(this.ruleForm.unitimageinfo)
                        this.ruleForm.unitpersonimageinfo = formatFileInfo(this.ruleForm.unitpersonimageinfo)
                        companyAuthMsg({
                            data: Object.assign({}, this.ruleForm),
                            success: data => {
                                if (data.code === '000') {
                                    this.$message({
                                        type: 'success',
                                        message: '提交成功'
                                    })
                                    this.$router.push('/accountMgt/accountAuth/accountAuthView')
                                } else {
                                    this.$message.error(data.msg)
                                }
                            },
                            error: data => {
                                this.$message.error(data.msg)
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
                }
            })
        },
        getCompanyImg(url) {
            this.ruleForm.unitimageinfo = url
        },
        getPersonImg(url) {
            this.ruleForm.unitpersonimageinfo = url
        },
        cancel() {
            this.$router.push('/accountMgt/accountAuth/accountAuthView')
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Upload
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.companyAuth {
    .idcardImage .avatar-uploader{
        box-sizing: border-box;
        width: 320px;
        height: 180px;
    }
    .title{
        font-size: $font-16;
        padding: 15px 0;
    }
    .business-license-cls{
        width: 216px;
        height: 144px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .handheld-idcard-cls{
        width: 186px;
        height: 186px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .el-upload__tip {
        color: $tcolor-grey;
    }
    .el-input{
        width: 400px;
    }
    .companyTitleAuthBox{
        font-weight: 500;
        font-size: 16px;
        span{
            color: #409EFF;
            margin-right: 5px;
        }
    }
}
</style>
